import $ from 'jquery';

let currentScrollY;
let unscrolled;
let ticking = false;

function checkUnscrolled(scrollY) {
    let unscrolledNow = scrollY < 1;

    if (unscrolledNow && !unscrolled) {
        $(document).trigger('balloon:unscrolled');
    }
    if (!unscrolledNow && unscrolled) {
        $(document).trigger('balloon:scrolled');
    }

    unscrolled = unscrolledNow;
}

function observeUnscrolled() {
    currentScrollY = window.scrollY;
    unscrolled = currentScrollY < 1;

    window.addEventListener('scroll', function (e) {
        currentScrollY = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(function () {
                checkUnscrolled(currentScrollY);
                ticking = false;
            });
            ticking = true;
        }
    });

    if (unscrolled) {
        $(document).trigger('balloon:unscrolled');
    } else {
        $(document).trigger('balloon:scrolled');
    }

}

export default observeUnscrolled;
